"use client";

import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type LoadingSpinnerProps = {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
};

export function LoadingSpinner({
  size = "md",
  showText = false,
}: LoadingSpinnerProps) {
  const { t } = useTranslation();

  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className={`${sizeClasses[size]} animate-spin mx-auto`} />
        {showText && <p className="mt-2">{t("loading")}</p>}
      </div>
    </div>
  );
}
